import { useTranslation } from 'react-i18next';
import type { FlatNamespace, KeyPrefix } from 'i18next';
import type { $Tuple } from 'react-i18next/helpers';
import { FallbackNs, UseTranslationOptions } from 'react-i18next';

export function useTranslations<
  Ns extends FlatNamespace | $Tuple<FlatNamespace> | undefined = undefined,
  KPrefix extends KeyPrefix<FallbackNs<Ns>> = undefined,
>(ns?: Ns, context?: string, options?: UseTranslationOptions<KPrefix>) {
  const { t } = useTranslation(ns, options);
  return (key: string, v = {}) =>
    t(key, {
      ...v,
      context,
    });
}
